var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenTickIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_161019",
    "data-name": "Group 161019",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1386",
    "data-name": "Group 1386"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_524",
    "data-name": "Rectangle 524",
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#00b717"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1385",
    "data-name": "Group 1385",
    transform: "translate(3.523 3.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M10.424,6,6.007,10.416,4,8.409",
    transform: "translate(-3.235 -4.119)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_534",
    "data-name": "Rectangle 534",
    width: 7,
    height: 7,
    transform: "translate(0.477 0.852)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickIcon);
export default __webpack_public_path__ + "static/media/green-tick-icon.80d3f1e6122355c6434a0dd5b427b2d8.svg";
export { ForwardRef as ReactComponent };